import { Injectable } from '@angular/core';

import { serialize, deserialize } from 'serialijse';
import { LocalStorageService } from 'ng2-webstorage';

import { ConfigService } from './config.service';
import { CartService } from './cart.service';
import { SessionState, ProductConfig, Param, Format, BtnToggleConfig, ValidParamConfig, KeyValue, Cart, ModelConfig } from './models';
import { ConfiguratorApiService } from '../commons/configurator-api.service';
import { LoadingPanelService } from '../commons/loading-panel.service';
import { Router } from '@angular/router';
import { PaymentType } from '../commons/models';

declare let SESSION_STATE: SessionState;

@Injectable()
export class SessionService {

  public lang: string = 'en';

  public _productConfig: ProductConfig;
  public code: string;
  public desc: string;
  public _params: Param[] = [];
  public partialHash: string;
  public hash: string;

  public oldLoadedProductXml: string;
  public oldModel: string;
  public thisModel: string;

  // Legate ai params
  public formats: Format[];
  public orientamento: string;
  public swapFormatSizes: boolean = false;
  public cropHeight: number = 30;
  public cropWidth: number = 20;
  public cornice: string;
  public errors: string;
  public page: number;
  public validParams: ValidParamConfig[] = [];
  public hiddenParams: Param[] = [];
  public othersParams: Param[] = [];

  lastChangeParam: Param;
  lastChangeValue: string;
  configureAsPackage: boolean;

  public btnToggles: BtnToggleConfig[];
  public sessionState: SessionState;
  public modelsVisible: ModelConfig[];

  constructor(
    private storage: LocalStorageService,
    private config: ConfigService,
    private cartService: CartService,
    private configApi: ConfiguratorApiService,
    private loadingPanel: LoadingPanelService,
    private router: Router
  ) {

    this.sessionState = SESSION_STATE;

    this.config.setPersistable();



    if (this.storage.retrieve('cart') !== null) {
      this.cartService.cart = deserialize<Cart>(this.storage.retrieve('cart'));
      console.log('CARICAto DA LOCAL STORAGE: CARTSERVICE', this.cartService.cart);
    }

    this.cartService.cartCheckProducts();

    if (this.storage.retrieve('session') !== null) {
      const loaded = <SessionPayload>this.storage.retrieve('session');
      SessionPayload.setSession(loaded, this);
      console.log('CARICATA DA LOCAL STORAGE:SESSION', this);
    }

    console.log(window.location.href.toString().indexOf('configurator-zodio'));
    if (window.location.href.toString().indexOf('configurator-zodio') !== -1) {
      this.config.isModeZodio = true;
    }
    console.log('this.config.isModeZodio', this.config.isModeZodio);

    // MODALITA' TOPCOLOR
    if (this.config.isModeZodio === false) {
      this.modelsVisible = this.config.models.filter(x => x.id !== 9);
      console.log('this.productConfig', this.productConfig);
      if (this.productConfig.idModel === 9) {
        console.log('setProduct primo products TOPCOLOR');
        this.setProduct(this.config.products.filter(x => x.idModel !== 9)[0], '', '');
      }
      this.cartService.cart.SelDeliveryOption.id = 1;
    }
    // MODALITA' DI ZODIO
    else {
      this.modelsVisible = this.config.models.filter(x => x.id === 9);
      // se non è impostato un prodotto Zodio lo forzo
      if (this.productConfig.idModel !== 9) {
        console.log('setProduct primo products ZODIO');
        this.setProduct(this.config.products.filter(x => x.idModel === 9)[0], '', '');
      }
      // FILTRO LE MODALITA' DI SPEDIZIONE
      this.config.deliveryOptions = this.config.deliveryOptions.filter(v => v.id === 2);
      this.cartService.cart.SelDeliveryOption.id = 2;
      // FILTRO LE MODALITA' PAGAMENTO
      this.config.paymentOptions = this.config.paymentOptions.filter(v => v.key === PaymentType.Bank);
      this.cartService.cart.paymentType = PaymentType.Bank;

    }

    console.log('TEST');
  }

  public setProduct(productConfig: ProductConfig, preFilterKey: string, preFilterValue: string) {
    console.log('productConfig', productConfig);
    console.log('preFilterKey', preFilterKey); // es: AccoppiamentoPannello
    console.log('preFilterValue', preFilterValue);// es: Legno
    // es: localhost:57136/configurator/#/load-product/30?url=possibili-accoppiamenti&preFilterKey=AccoppiamentoPannello&preFilterValue=Forex


    console.log('this.cartService.cart', this.cartService.cart);

    let prefName = '';
    if (preFilterKey) {
      productConfig.preFilters.forEach(v => {
        if (v.key === preFilterKey) {
          v.selectedValue = preFilterValue;
          prefName = ' - ' + preFilterValue;
        }
      });
    }

    this.productConfig = productConfig;

    this.thisModel = productConfig.name + prefName;

    // if (!this.cartService.cart.currentCartProduct)
    //   this.cartService.cart.currentCartProduct = new CartProduct();


    if (!this.cartService.cart.currentCartProduct) {
      console.log('cartService.cart.currentCartProduct NON DEFINITO', this.cartService.cart.currentCartProduct);
      this.cartService.addProduct(productConfig.id, 1);
    }

    this.cartService.cart.currentCartProduct.config = productConfig;
    // this.cartService.cart.currentCartProduct.productName = 'SET: ' +  productConfig.name; // + prefName;
    this.cartService.cart.currentCartProduct.idProduct = productConfig.id;

    console.log('setProduct');
    console.log(this.cartService.cart.currentCartProduct.config);
    console.log(this.cartService.cart.currentCartProduct.productName);

    this.cartService.saveCart();
    this.getParamTree();
    this.saveSession();

    this.router.navigate(['/upload-photo']);

  }

  public saveSession() {
    console.log('saveSession - cart', this.cartService.cart);
    console.log('saveSession - session', SessionPayload.loadFromSession(this));
    this.config.setPersistable();
    this.storage.store('cart', serialize(this.cartService.cart));
    this.storage.store('session', SessionPayload.loadFromSession(this));
  }

  public isLogged() {
    // return this.sessionState && this.sessionState.token;
    return this.sessionState.username !== 'Guest';
  }

  // get price(): number {
  //   let cprice = this.getParam('Price', this.params);
  //   if (!cprice) { return null; }
  //   return parseFloat(cprice.selectedValue);
  // }

  get productConfig() {
    if (!this._productConfig) {
      console.log('VALORIZZO this._productConfig perchè non definito');
      if (this.cartService.cart) {
        if (this.cartService.cart.currentCartProduct.config) {
          this._productConfig = this.cartService.cart.currentCartProduct.config;
        } else {
          this._productConfig = this.config.products[0];
        }
      } else {
        this._productConfig = this.config.products[0];
      }
    }
    return this._productConfig;
  }
  set productConfig(product: ProductConfig) {
    this._productConfig = product;
  }

  get outputUrl(): string {
    return this.config.outputBaseUrl.replace('{lang}', this.lang);
  }

  get params(): Param[] {
    return this._params;
  }
  set params(prms: Param[]) {
    this._params = prms.sort((p1, p2) => ((p1.page - p2.page) * 1000) + (p1.sort - p2.sort));

    // NO PERCHE' NON C'E' CORRISPONDENZA (cambia il prezzo tra prodotti che è compreso nel param)
    // this.selectFormat = this.getParamValue('ListaFormati', prms, null);

    if (this.cartService.cart.currentCartProduct.config.preFilters) {
      this.cartService.cart.currentCartProduct.config.preFilters.filter(pf => pf.showOnlyThis).forEach(pf => {
        let p = this.getParam(pf.key, this.params);
        if (p) {
          p.values = p.values.filter(v => pf.values.indexOf(v.value) >= 0);
        }
      });
    }

    this.orientamento = this.getParamValue('FormatoOrientamento', prms, null);
    this.swapFormatSizes = this.getParamValue('FormatoOrientamento', prms, null) === 'Formato_Landscape';
    this.cropHeight = Number(this.getParamValue('CropHeight', prms, null));
    this.cropWidth = Number(this.getParamValue('CropWidth', prms, null));
    this.cornice = this.getParamValue('Cornice', prms, null);

    // Imposta il formato corrente con quello che ritorna l'api
    let formatG = this.getParamValue('FormatoGruppo', this.params, '');
    let format = this.getParamValue('Formato', this.params, '');

    if (this.cartService.cart.currentCartProduct) {

      this.cartService.cart.currentCartProduct.format = formatG + '|' + format;

      this.cartService.cart.currentCartProduct.rounded =
        (this.cartService.cart.currentCartProduct.format != null ?
          (this.cartService.cart.currentCartProduct.format.indexOf('O') !== -1) : false);

      this.cartService.cart.currentCartProduct.price = Number(this.getParamValue('Price', prms, null));
      this.cartService.cart.currentCartProduct.cornicePrice = Number(this.getParamValue('CornicePrice', prms, null));
      this.cartService.cart.currentCartProduct.additionalPrice = Number(this.getParamValue('AdditionalPrice', prms, null));

      // recupero valore param NomeProdotto
      console.log(' recupero valore param NomeProdotto per .productName');
      let NomeProdotto = this.getParamValue('NomeProdotto', prms, null);
      if (NomeProdotto) {
        this.cartService.cart.currentCartProduct.productName = NomeProdotto;
        console.log('cambiato NomeProdotto .productName ', NomeProdotto);
      }


      // Faccio il parse della lista dei formati // es: F_4X3|80_x_60|80|60|200|"
      let ff = prms.filter(p => p.name === 'ListaFormati');
      if (ff.length === 0) {
        this.formats = [];
      } else {
        this.formats = ff[0].values.map(p => {
          let f = new Format();
          let s = p.value.split('|');
          f.format = s[0];
          f.dimensions = s[1];
          f.width = Number(s[2]);
          f.height = Number(s[3]);
          f.price = parseFloat(s[4]);
          f.priceDiscounted = parseFloat(s[5]);
          f.valueParam = p.value;
          return f;
        });
      }

      // RECUPERO DALLA NUOVA LISTA FORMATI IL PARAM DA REIMPOSTARE MANUALMENTE (se presente)
      let filterFormat = this.formats.filter(r => r.dimensions === this.cartService.cart.currentCartProduct.format.split('|')[1]);
      if (filterFormat[0]) {
        let recordFormat = filterFormat !== null ? filterFormat[0].valueParam : null;

        if (recordFormat !== null) {
          let paramFormat = this.getParam('Formato', this.cartService.cart.currentCartProduct.params);
          if (paramFormat) {
            if (paramFormat.values.filter(p => p.value === recordFormat).length !== 0) {
              paramFormat.selectedValue = recordFormat;
            }
          }

          paramFormat = this.getParam('Formato', this.params);
          if (paramFormat) {
            if (paramFormat.values.filter(p => p.value === recordFormat).length !== 0) {
              paramFormat.selectedValue = recordFormat;
            }
          }
        }
      }
    }
  }

  getParam(name: string, prms: Param[]) {
    if (prms && prms.length !== 0) {
      let paramFormat = prms.filter(p => p.name === name);
      if (paramFormat && paramFormat.length !== 0) {
        return paramFormat[0];
      }
    }

    return null;
  }

  getParamValue(name: string, prms: Param[], defaultValue: string): string {
    if (!prms) {
      prms = this.params;
    }

    let prm = prms.filter(p => p.name === name);
    if (prm.length === 0) {
      return defaultValue;
    }

    return prm[0].selectedValue;
  }

  setParamLists(page: number) {
    let ret: ValidParamConfig[] = [];

    // creo un dictionary con chiave 'page' e valore l'array di param
    this.params
      .filter(p => p.table === 'Parameters' || p.table === 'Formats' || p.table.startsWith('Navbar'))
      .forEach(p => {

        if (!ret[p.page]) {
          ret[p.page] = { page: p.page, params: [], hidden: true };
        }
        ret[p.page].params.push(p);

        if (p.image) {
          ret[p.page].image = p.name;
        }

        p.class = 'col-md-12';

        if (p.type === 'Combo') {
          p.class = 'col-md-4 padding-r-none';
        } else if (p.type === 'Label') {
          p.class = '';
        }

        if (p.type !== 'Hidden') {
          ret[p.page].hidden = false;
        }

      });

    // toglie gli undefined creati dall'accesso dichiarativo all'array
    this.validParams = ret.filter(r => r);

    // lista parametri nascosti (e per ora non Parameters)
    this.hiddenParams = this.params
      .filter(p => p.type === 'Hidden' && p.table === 'Parameters');

    this.othersParams = this.params; // this.params.filter(x => x.table !== 'Parameters');
  }

  getParamTree() {
    console.log('GET PARAMTREE',
      this.cartService.cart.currentCartProduct.config.xml,
      this.oldModel,
      this.thisModel
    );
    // console.log('getParamTree - configurator - ' + this.productConfig.xml);
    if (!!this.cartService.cart.currentCartProduct.config.xml) {

      // if (this.oldLoadedProductXml !== this.productConfig.xml) {
      if (this.oldModel !== this.thisModel || (!this.oldModel)) {
        this.oldLoadedProductXml = this.cartService.cart.currentCartProduct.config.xml;
        this.oldModel = this.thisModel;

        console.log(`get default params tree from model ${this.cartService.cart.currentCartProduct.config.xml}`);
        this.errors = null;

        this.loadingPanel.start();

        let preFilters = [];
        if (this.cartService.cart.currentCartProduct.config.preFilters) {

          this.cartService.cart.currentCartProduct.config.preFilters.forEach(f => {
            preFilters.push({ name: f.key, selectedValue: f.selectedValue });
            // console.log(f.key + f.selectedValue);
          });
          // this.productConfig.preFilters.forEach(f => preFilters.push({ name: f.key, selectedValue: f.selectedValue }));
        }

        if (this.params) {
          let toSave = this.params.filter(p => this.config.paramsToSaveKeys.indexOf(p.name) >= 0);
          toSave.forEach(p => preFilters.push(p));
        }

        this.configApi.load(this.cartService.cart.currentCartProduct.config.xml, preFilters).subscribe(

          tree => {
            this.code = tree.code;
            this.desc = tree.desc;
            this.params = tree.parameters;
            // console.log('PARAMS: getParamTree');
            this.partialHash = tree.partialHash;
            this.hash = tree.hash;
            this.page = tree.parameters.map(p => p.page).sort()[0];

            this.setParamLists(this.page);
            this.updateCartParams();
            this.setBtnToggle(tree.parameters);

            this.loadingPanel.complete();
          },
          error => {
            console.warn(error);
            this.errors = error;

            this.loadingPanel.complete();
          });
      } else {
        this.setParamLists(this.page);
        this.setBtnToggle(this.params);
      }
    } else {
      console.warn('no model passed');
    }
  }

  setBtnToggle(params: Param[]) {

    // console.log('setBtnToggle', params);

    // ELIMINO I PULSANTI PARAMETRI PER POI RIAGGIUNGERLI OGNI VOLTA
    this.config.btnToggles = this.config.btnToggles.filter(r => r.isParameter === false);
    let i = 10;
    let tables = params.filter(r => r.type !== 'Hidden').map(p => p.table);
    tables = tables.filter((item, pos) => tables.indexOf(item) === pos); // DISTINCT

    tables.forEach(table => {
      if (table.startsWith('Navbar')) {
        let name = table.substr('Navbar'.length);
        i++;

        let newBtn: BtnToggleConfig = {
          id: i,
          sort: i,
          url: 'slide-parameter/' + name,
          text: table,
          isMenu: true,
          isParameter: true,
          isActive: true
        };

        let indexOfPuls = this.config.btnToggles.indexOf(this.config.btnToggles.filter(r => r.id === newBtn.id)[0]);
        if (indexOfPuls === -1) {
          this.config.btnToggles.push(newBtn);
        }

        this.config.btnToggles = this.config.btnToggles.sort((a, b) => {
          if (a.sort < b.sort) {
            return -1;
          } else if (a.sort > b.sort) {
            return 1;
          } else { return 0; }
        });


      }
    });
  }

  updateCartParams() {
    if (this.cartService.cart.currentCartProduct) {
      this.cartService.cart.currentCartProduct.params = this.params;
    }
  }

  changeParam(param: Param, value: string) {
    this.lastChangeParam = param;
    this.lastChangeValue = value;


    let isPackage = param.values.filter(p => p.value === value)[0].package;
    this.errors = null;
    this.loadingPanel.start();
    let wasPackage = (this.validParams.filter(p => !p.isPackage).length === 0);
    let newParams: KeyValue[] = null;
    /// CUSTOM PARAMETERS
    // Lista formati
    if (param.name === 'ListaFormati') {
      let split = value.split('|');
      newParams = [
        { key: 'FormatoGruppo', value: split[0] },
        { key: 'Formato', value: split[1] },
        { key: 'ListaFormati', value: value }
      ];
    }

    if (!newParams) {
      this.configApi.update(
        this.cartService.cart.currentCartProduct.config.xml,
        this.params,
        param.name,
        value,
        this.configureAsPackage && wasPackage && isPackage
      ).subscribe(
        tree => {
          this.code = tree.code;
          this.desc = tree.desc;
          this.params = tree.parameters;
          this.partialHash = tree.partialHash;
          this.hash = tree.hash;
          let page = this.page + 1;
          this.setParamLists(page);

          this.saveSession();
          this.updateCartParams();

          this.loadingPanel.complete();
        },
        error => {
          console.warn(`changeParam error: ${error}`);
          this.errors = error;

          this.loadingPanel.complete();
        });
    } else {
      this.configApi.multiupdate(
        this.cartService.cart.currentCartProduct.config.xml,
        this.params,
        newParams,
        this.configureAsPackage && wasPackage && isPackage
      ).subscribe(
        tree => {
          this.code = tree.code;
          this.desc = tree.desc;
          this.params = tree.parameters;
          this.partialHash = tree.partialHash;
          this.hash = tree.hash;
          let page = this.page + 1;
          this.setParamLists(page);

          this.saveSession();
          this.updateCartParams();

          this.loadingPanel.complete();
        },
        error => {
          console.warn(`changeParam error: ${error}`);
          this.errors = error;

          this.loadingPanel.complete();
        });
    }



  }
}



export class SessionPayload {
  public lang: string;
  public _productConfig: ProductConfig;
  public code: string;
  public desc: string;
  public _params: Param[];
  public partialHash: string;
  public hash: string;

  public oldLoadedProductXml: string;
  public oldModel: string;
  public thisModel: string;

  public formats: Format[];
  public orientamento: string;
  public swapFormatSizes: boolean;
  public cropHeight: number;
  public cropWidth: number;
  public cornice: string;

  public errors: string;

  public page: number;
  public validParams: ValidParamConfig[];
  public hiddenParams: Param[];
  public othersParams: Param[];

  public lastChangeParam: Param;
  public lastChangeValue: string;
  public configureAsPackage: boolean;

  public btnToggles: BtnToggleConfig[];

  public sessionState: SessionState;


  public static loadFromSession(session: SessionService) {
    let payload = new SessionPayload();
    payload.lang = session.lang;
    payload._productConfig = session._productConfig;
    payload.code = session.code;
    payload.desc = session.desc;
    payload._params = session._params;
    payload.partialHash = session.partialHash;
    payload.hash = session.hash;

    payload.oldLoadedProductXml = session.oldLoadedProductXml;
    payload.oldModel = session.oldModel;
    payload.thisModel = session.thisModel;

    payload.formats = session.formats;
    payload.orientamento = session.orientamento;
    payload.swapFormatSizes = session.swapFormatSizes;
    payload.cropHeight = session.cropHeight;
    payload.cropWidth = session.cropWidth;
    payload.cornice = session.cornice;

    payload.errors = session.errors;

    payload.page = session.page;
    payload.validParams = session.validParams;
    payload.hiddenParams = session.hiddenParams;
    payload.othersParams = session.othersParams;

    payload.lastChangeParam = session.lastChangeParam;
    payload.lastChangeValue = session.lastChangeValue;
    payload.configureAsPackage = session.configureAsPackage;

    payload.btnToggles = session.btnToggles;

    payload.sessionState = session.sessionState;

    return payload;
  }

  public static setSession(loaded: SessionPayload, session: SessionService) {
    console.log('SetSession');
    session.lang = loaded.lang;
    session.productConfig = loaded._productConfig;
    session.code = loaded.code;
    session.desc = loaded.desc;
    session.params = loaded._params;
    session.partialHash = loaded.partialHash;
    session.hash = loaded.hash;

    session.oldLoadedProductXml = loaded.oldLoadedProductXml;
    session.oldModel = loaded.oldModel;
    session.thisModel = loaded.thisModel;

    session.formats = loaded.formats;
    session.orientamento = loaded.orientamento;
    session.swapFormatSizes = loaded.swapFormatSizes;
    session.cropHeight = loaded.cropHeight;
    session.cropWidth = loaded.cropWidth;
    session.cornice = loaded.cornice;

    session.errors = loaded.errors;

    session.page = loaded.page;
    session.validParams = loaded.validParams;
    session.hiddenParams = loaded.hiddenParams;
    session.othersParams = loaded.othersParams;

    session.lastChangeParam = loaded.lastChangeParam;
    session.lastChangeValue = loaded.lastChangeValue;
    session.configureAsPackage = loaded.configureAsPackage;

    session.btnToggles = loaded.btnToggles;

    // session.sessionState = loaded.sessionState; //NON LA RISETTO PERCHE' ALTRIMENTI NON CONSIDERA LA SESSIONE DEL LOGIN MA QUELLA PRECEDENTE
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/session.service.ts